import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=5401426b&scoped=true"
import script from "./trend.js?vue&type=script&lang=js&external"
export * from "./trend.js?vue&type=script&lang=js&external"
import style0 from "./trend.vue?vue&type=style&index=0&id=5401426b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401426b",
  null
  
)

export default component.exports